import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../contexts/LanguageContext';
import { useSiteConfig, pickI18n } from '../contexts/SiteConfigContext';
import { Calendar } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const { lang } = useLang();
  const { config } = useSiteConfig();
  const navigate = useNavigate();
  const hero = config.hero || {};
  const colors = config.identity?.colors || {};

  const bgStyle = hero.bg_image
    ? {
        backgroundImage: `url(${hero.bg_image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    : {
        background:
          'linear-gradient(135deg, #fdf2f5 0%, #fbe6ee 50%, #f7d9e5 100%)',
      };

  return (
    <section className="relative pt-36 pb-28 lg:pt-44 lg:pb-36" style={bgStyle}>
      {hero.bg_image && (
        <div className="absolute inset-0 bg-white/30 pointer-events-none" />
      )}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 text-center lg:text-start">
          <p
            className="text-sm md:text-base mb-6 tracking-[0.25em] uppercase font-medium"
            style={{ color: colors.accent || '#b54e7d' }}
          >
            {pickI18n(hero.welcome, lang)}
          </p>

          <h1
            className="font-display mb-8"
            style={{
              color: colors.text_dark || '#5a1d3b',
              fontSize: 'clamp(2.4rem, 4.6vw, 4.25rem)',
              fontWeight: 500,
              lineHeight: 1.12,
              letterSpacing: '-0.01em',
            }}
          >
            {pickI18n(hero.title, lang)}
          </h1>

          <p
            className="text-gray-700 max-w-xl mx-auto lg:mx-0 mb-12"
            style={{ fontSize: 'clamp(1rem, 1.15vw, 1.125rem)', lineHeight: 1.85 }}
          >
            {pickI18n(hero.description, lang)}
          </p>

          <div className="flex justify-center lg:justify-start">
            <Button
              onClick={() => navigate('/booking')}
              size="lg"
              className="btn-rose text-white rounded-full px-9 h-14 text-base gap-2.5 shadow-md font-medium"
              style={{ backgroundColor: colors.primary || '#c4477a' }}
            >
              <Calendar className="w-4 h-4" />
              {pickI18n(hero.cta_text, lang)}
            </Button>
          </div>
        </div>

        <div className="lg:col-span-5 flex justify-center lg:justify-end">
          {hero.logo_image && (
            <img
              src={hero.logo_image}
              alt={config.identity?.site_name || ''}
              className="w-full max-w-[440px] lg:max-w-[480px] h-auto object-contain"
              style={{ mixBlendMode: 'multiply' }}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
